import { render, staticRenderFns } from "./loan-status.vue?vue&type=template&id=cb1e1bba&scoped=true&lang=pug&"
import script from "./loan-status.vue?vue&type=script&lang=js&"
export * from "./loan-status.vue?vue&type=script&lang=js&"
import style0 from "./loan-status.vue?vue&type=style&index=0&id=cb1e1bba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e1bba",
  null
  
)

export default component.exports